<template>
  <div class='coursework-viewer__slide js-previewable'>
    <div class='row js-previewable-loading' v-if="loading">
      <div class='col-xs-12 col-sm-6 col-md-3 center txt-c mt2 mb2'>
        <i class='svg-icon svg-icon__clr-dark svg-icon mb1'></i>
        <div class='missing-content__title mt0'>Loading...</div>
        <div class='typo__body mt1'>Please wait while we load this document</div>
      </div>
    </div>
  </div>
</template>

<script>
  import IframeDocumentRenderer from './../../../iframe-document-renderer';
  export default {
    props: {
      media: Object
    },
    data() {
      return {
        loading: true
      }
    },
    methods: {
      init() {
        let renderer = new IframeDocumentRenderer({
          id: this.media.id,
          route: this.media.preview_path,
          $container: $(this.$el),
          style: { height: 800 },
          onLoad: () => {
            this.loading = false;
            this.$emit('ready', this.media.id)
          }
        });
        renderer.present();
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.init();
    }
  }
</script>